import { ComponentsVariants, isVariantOf } from '@/components.variants';
import resolveLink from '../resolveLink';

interface MyBusinessRawProps {
  groupTitle?: string;
  link: any[];
  powerAppsCtas: any[];
}

export const isMyBusiness = isVariantOf(ComponentsVariants.MY_BUSINESS, true);

export default (ravVal: MyBusinessRawProps, page: any, pageModels: any) => {
  const { groupTitle, powerAppsCtas, link } = ravVal;
  return {
    variant: ComponentsVariants.MY_BUSINESS,
    title: groupTitle,
    links: link.map((val) => resolveLink({ rawVal: val, page, pageModels })),
    powerAppsCtas: powerAppsCtas.map((cta) => ({
      powerAppsOption: cta?.powerAppsOption,
      link: resolveLink({ rawVal: cta?.link, page, pageModels }),
    })),
  };
};
